'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TICKET = exports.TICKET = 'TICKET';